var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerPayrollPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40133 5.49244H7.83334V7.29547H1.52273V0.984863H3.32576V3.93313C4.88097 2.05092 7.10831 0.984863 9.63637 0.984863C14.6153 0.984863 18.6515 5.02108 18.6515 10C16.8485 10 18.6515 10 16.8485 10C16.8485 6.01687 13.6195 2.78789 9.63637 2.78789C7.47848 2.78789 5.62782 3.76035 4.40133 5.49244ZM14.8714 14.5076H11.4394V12.7046H17.75V19.0152H15.947V16.0669C14.3918 17.9491 12.1644 19.0152 9.63637 19.0152C4.65744 19.0152 0.621216 14.9789 0.621216 10H2.42425C2.42425 13.9832 5.65322 17.2121 9.63637 17.2121C11.7943 17.2121 13.6449 16.2397 14.8714 14.5076Z",
    fill: "#3F2E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerPayrollPending);
export default __webpack_public_path__ + "static/media/customer-payroll-pending.a63643198162d79b993e86981124de96.svg";
export { ForwardRef as ReactComponent };